import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import classnames from 'classnames';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import ContactForm from '../../../components/ContactForm';
import { BREAKPOINTS } from '../../../utils/commonHelper';
import { listingPropTypes } from '../../../utils/commonPropTypes';
import { getTitle, getSanitisedDealerName } from '../../../utils/listingHelper';
import { scrollTo } from '../../../utils/scrollTo';
import messages from '../../../utils/translationMessages';
import StickyContact from '../StickyContact';
import SellerInformation from '../../../components/SellerInformation';
import './styles.css';

class DetailsContact extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      open: props.initialState === 'open',
      searchConfig: {}
    };

    this.handleClose = this.handleClose.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
    this.setState({
      searchConfig: get(
        JSON.parse(window.localStorage.getItem('nextPreviousData')),
        'searchParams',
        {}
      )
    });
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.isLoading &&
      this.state.open &&
      this.props.initialState !== 'open'
    ) {
      this.setState({
        open: false
      });
    } else if (prevProps.externalOpen !== this.props.externalOpen) {
      this.setState({ open: this.props.externalOpen }, () => {
        if (!prevProps.isModal) {
          scrollTo('#details-contact-anchor', { behavior: 'smooth' });
        }
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  setWrapperRef = (node) => {
    this.wrapperRef = node;
  };

  handleClickOutside = (event) => {
    if (
      this.state.open &&
      this.props.toggle &&
      this.wrapperRef &&
      !this.wrapperRef.contains(event.target)
    ) {
      this.setState({
        open: false
      });
    }
  };

  handleOpen = () => {
    if (typeof this.props.onCarouselContactButton === 'function') {
      this.props.onCarouselContactButton();
    } else {
      this.setState(
        (prevState) => ({ open: this.props.toggle ? !prevState.open : true }),
        () => scrollTo('#details-contact-anchor', { behavior: 'smooth' })
      );
    }
  };

  handleClose = () => {
    this.setState({ open: false });
    this.props.onClose();
  };

  getContactFormProperties() {
    const { id, intl, listing, origin, scrolled, showManufacturerForm } =
      this.props;

    const { formatMessage: t } = intl;
    const contactFormProperties = {
      itemId: listing.id,
      id,
      contactSubmitTrack: true,
      prePopulatedText:
        this.props.prePopulatedText ||
        t(messages.contactForm.prePopulatedText, {
          listingTitle: getTitle(listing)
        }),
      labelText: {
        name: t(messages.contactForm.firstName),
        email: t(messages.contactForm.email),
        phone: t(messages.contactForm.phone),
        comments: t(messages.contactForm.comments),
        firstName: t(messages.contactForm.firstName),
        zip: t(messages.postalCode),
        country: t(messages.contactForm.country)
      },
      placeholderText: {
        name: t(messages.contactForm.fullName),
        email: t(messages.contactForm.yourEmail),
        phone: t(messages.contactForm.yourPhone),
        comments: t(messages.contactForm.comments),
        firstName: t(messages.contactForm.firstName),
        zip: t(messages.postalCode),
        country: t(messages.contactForm.selectCountry)
      },
      orderInputs: ['name', 'phone', 'email', 'comments', 'firstName'],
      mode: 'details',
      listing,
      onClose: this.handleClose
    };

    if (!showManufacturerForm) {
      contactFormProperties.origin = origin;
      contactFormProperties.scrolled = scrolled;
    } else {
      contactFormProperties.isOemManufactuer = true;
      contactFormProperties.contactButtonText = t(
        messages.contactGroup.contact
      );
      contactFormProperties.prePopulatedText = t(
        messages.contactForm.prePopulatedText,
        { listingTitle: getTitle(listing) }
      );
      contactFormProperties.id = `modal-oem-${id}`;
      contactFormProperties.oemId = get(listing, 'owner.id');
      contactFormProperties.brandId = get(listing, 'oemDetails.brandId');

      const isUS = intl.locale === 'us';
      contactFormProperties.showZipCode = isUS;
      contactFormProperties.showCountry = !isUS;
      contactFormProperties.orderInputs = isUS
        ? ['name', 'email', 'phone', 'zip', 'comments']
        : ['name', 'email', 'phone', 'country', 'comments'];
    }

    return contactFormProperties;
  }

  showManufacturerLogo() {
    const { listing } = this.props;
    return (
      <div className="seller-information">
        <div className="manufacturer-logo">
          <img src={get(listing, 'owner.logos.default')} alt={listing.make} />
        </div>
      </div>
    );
  }

  showSellerInformation() {
    const { breakpoint, listing, revealDealerPhoneNumber, isModal } =
      this.props;

    return (
      <SellerInformation
        breakpoint={breakpoint}
        contact={listing.contact}
        name={getSanitisedDealerName(listing.owner)}
        listingId={listing.id}
        revealDealerPhoneNumber={revealDealerPhoneNumber}
        isModal={isModal}
      />
    );
  }

  render() {
    const { isLoading, listing, disableSticky, showManufacturerForm, intl } =
      this.props;

    // Prevent the SellerInformation component to render while PROPS have not been loaded.
    const renderSellerInformation = !isEmpty(listing.contact);
    const contactFormProperties = this.getContactFormProperties();
    const { formatMessage: t } = intl;

    return (
      <div
        id={this.props.id}
        className={classnames('details-contact', { open: this.state.open })}
        ref={this.setWrapperRef}
      >
        <div id="details-contact-anchor"></div>
        {!isLoading && (
          <div className="contact-area">
            {this.props.isModal && (
              <button
                type="button"
                className="modal-close"
                onClick={this.handleClose}
              >
                <span className="visuallyhidden">
                  {t(messages.contactForm.close)}
                </span>
              </button>
            )}
            {renderSellerInformation &&
              !showManufacturerForm &&
              this.showSellerInformation()}
            {showManufacturerForm && this.showManufacturerLogo()}
            {this.state.open && (
              <ContactForm open={this.state.open} {...contactFormProperties} />
            )}
          </div>
        )}
        {!disableSticky && (
          <StickyContact
            isLoading={isLoading}
            listing={listing}
            isOpening={this.state.open === false}
            onOpenContact={this.handleOpen}
            isManufacturer={showManufacturerForm}
          />
        )}
      </div>
    );
  }
}

DetailsContact.defaultProps = {
  disableSticky: false,
  initialState: 'closed',
  isLoading: false,
  toggle: false,
  isModal: false,
  revealDealerPhoneNumber: false,
  prePopulatedText: ''
};

DetailsContact.propTypes = {
  /** Current screen size breakpoint */
  breakpoint: PropTypes.oneOf(Object.keys(BREAKPOINTS)),
  /** If true the StickyContact is hidden */
  disableSticky: PropTypes.bool,
  /** Lets the parent component decide the open state */
  externalOpen: PropTypes.bool,
  /** Initial state */
  initialState: PropTypes.oneOf(['open', 'closed']),
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
    locale: PropTypes.string
  }).isRequired,
  isLoading: PropTypes.bool,
  /** Listing information of the boat */
  listing: listingPropTypes.isRequired,
  toggle: PropTypes.bool,
  isModal: PropTypes.bool,
  showManufacturerForm: PropTypes.bool,
  revealDealerPhoneNumber: PropTypes.bool,
  origin: PropTypes.string,
  scrolled: PropTypes.bool,
  id: PropTypes.string,
  prePopulatedText: PropTypes.string,
  onClose: PropTypes.func,
  onCarouselContactButton: PropTypes.func
};

export default injectIntl(DetailsContact);
